import React from 'react'
import { Input as ShadcnInput } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { cn } from '@/lib/utils'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  bsSize?: 'sm' | 'lg'
  valid?: boolean
  invalid?: boolean
  tag?: React.ElementType
  innerRef?: React.Ref<any>
  plaintext?: boolean
  children?: React.ReactNode
  rows?: number
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ bsSize, valid, invalid, className, innerRef, plaintext, tag, type, children, rows, ...props }, ref) => {
    const sizeClasses = cn(
      bsSize === 'sm' && 'h-8 text-sm',
      bsSize === 'lg' && 'h-12 text-lg',
      invalid && 'border-destructive',
      valid && 'border-[hsl(var(--success))]',
      className,
    )

    // Reactstrap <Input type="select"> renders a <select>
    if (type === 'select') {
      return (
        <select
          ref={innerRef || ref as any}
          className={cn(
            'flex h-10 w-full appearance-none rounded-md border border-input bg-card px-3 py-2 pr-8 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
            'bg-[length:16px_16px] bg-[right_8px_center] bg-no-repeat',
            "bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%236b7280%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpath%20d%3D%22m6%209%206%206%206-6%22%2F%3E%3C%2Fsvg%3E')]",
            sizeClasses,
          )}
          {...props as any}
        >
          {children}
        </select>
      )
    }

    // Reactstrap <Input type="textarea"> renders a <textarea>
    if (type === 'textarea') {
      return (
        <Textarea
          ref={innerRef || ref as any}
          rows={rows}
          className={cn(sizeClasses)}
          {...props as any}
        />
      )
    }

    return (
      <ShadcnInput
        ref={innerRef || ref}
        type={type}
        className={cn(sizeClasses)}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'
